import React, { useEffect, useState } from 'react';
import { Button, Modal, Col, Stack, Row, Form } from 'react-bootstrap';

export default function DebrisIndexButtonModal({
    visibleOdontogram,
    setVisibleOdontogram,
    activeIndex,
    setActiveIndex
}) {
    const isActive = activeIndex === "debris";
    const handleClick = () => {
        if (isActive) {
            setActiveIndex("");
        } else {
            setActiveIndex("debris");
        }
    };
    return (
        <>

            <Button
                variant={isActive ? "success" : "primary"}
                size="sm"
                onClick={handleClick}
                className="w-100"
            >
                Debris Index
            </Button>
            {/* {visibleOdontogram &&
                <>
                    <Button
                        variant={visibleOdontogram ? "primary" : "success"}
                        size="sm"
                        onClick={() => setVisibleOdontogram(!visibleOdontogram)}
                        className='w-100'
                    >
                        Debris Index
                    </Button>
                </>
            } */}
        </>
    )
}
